import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../features/auth/services/auth';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const token: any = localStorage.getItem('ShuwierToken');

  if (!token) {
    router.navigate(['login']);
    return false;
  }
  return true;
};
